(ns ui.view.counterparty-diligence.send-to-responders-modal.model
  (:require
   [frontend.tenant-customizations :as tenant-customizations]
   [common.localization :as loc]))

(def root-path [::state])

(def modal-open-path [:modal-open?])

(def modal-open-full-path (into root-path modal-open-path))

(def email-subject-path [:email-subject])

(def email-subject-full-path (into root-path email-subject-path))

(def email-body-path [:email-body])

(def email-body-full-path (into root-path email-body-path))

(def new-responders-path [:new-responders])

(def new-responders-full-path (into root-path new-responders-path))

(def submitting-path [:submitting?])

(def submitting-full-path (into root-path submitting-path))

(def removing-responders-path [:removing-responders])

(def removing-responders-full-path (into root-path removing-responders-path))

(defn default-email-subject
  []
  (cond
    (tenant-customizations/capman?)
    (loc/tr :capman-project-counterparty-diligence-default-email-subject)

    :else ""))

(defn default-email-body
  []
  (cond
    (tenant-customizations/capman?)
    (loc/tr :capman-project-counterparty-diligence-default-email-body)

    :else ""))
